<template>
<div class="animated fadeIn mt-5">
  <form enctype="multipart/form-data" v-on:submit="validateBeforeSubmit($event,false)">
    <div class="row">
      <b-col md="6">
        <b-card>
          <div slot="header">
            <strong>Item</strong>
          </div>
          <b-form-group label="Nome">
            <b-form-input type="text" name="name" v-model="item.name" placeholder="Nome"  v-validate="'required'" :state="validateState('name')"></b-form-input>
            <b-form-invalid-feedback>
              {{ errors.first('name') }}
            </b-form-invalid-feedback>
          </b-form-group>
          <b-form-row>
            <b-col md="4">
              <b-form-group label="Início">
                <b-form-input type="number" step="1" min="201801" name="ym_start" v-model="item.ym_start" placeholder="Início"  v-validate="'required'" :state="validateState('ym_start')"></b-form-input>
                <b-form-invalid-feedback>
                  {{ errors.first('ym_start') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group label="Fim">
                <b-form-input type="number" step="1" min="201801" name="ym_end" v-model="item.ym_end" placeholder="Fim"  v-validate="'required'" :state="validateState('ym_end')"></b-form-input>
                <b-form-invalid-feedback>
                  {{ errors.first('ym_end') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group label="Estado" >
                <b-form-select :options="stateOptions" name="state" v-model="item.state" placeholder="Estado"  v-validate="'required'" :state="validateState('state')" ></b-form-select>

                <b-form-invalid-feedback>
                  {{ errors.first('code') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>

          </b-form-row>
          <b-form-row>

            <b-col md="4">
              <b-form-group label="Obj Valor" >
                <b-form-select :options="stateOptions" name="enable_value" v-model="item.enable_value" placeholder="Obj Valor"  v-validate="'required'" :state="validateState('enable_value')" ></b-form-select>
                <b-form-invalid-feedback>
                  {{ errors.first('enable_value') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group label="Obj Operadores" >
                <b-form-select :options="stateOptions" name="enable_operators" v-model="item.enable_operators" placeholder="Obj Operadores"  v-validate="'required'" :state="validateState('enable_operators')" ></b-form-select>
                <b-form-invalid-feedback>
                  {{ errors.first('enable_operators') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group label="Obj Qtd" >
                <b-form-select :options="stateOptions" name="enable_quantity" v-model="item.enable_quantity" placeholder="Obj Qtd"  v-validate="'required'" :state="validateState('enable_quantity')" ></b-form-select>
                <b-form-invalid-feedback>
                  {{ errors.first('enable_quantity') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-form-row>
          <b-form-fieldset label="Multiplicador por objectivos cumpridos:">
            <b-form-row>
              <b-col md="4">
                <b-form-group label="1 objectivo">
                  <b-form-input type="number" step="1" min="0" name="points_multiplier1" v-model="item.points_multiplier1" placeholder="1 objectivo"  v-validate="'required'" :state="validateState('points_multiplier1')"></b-form-input>
                  <b-form-invalid-feedback>
                    {{ errors.first('points_multiplier1') }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group label="2 objectivos">
                  <b-form-input type="number" step="1" min="0" name="points_multiplier2" v-model="item.points_multiplier2" placeholder="2 objectivos"  v-validate="'required'" :state="validateState('points_multiplier2')"></b-form-input>
                  <b-form-invalid-feedback>
                    {{ errors.first('points_multiplier2') }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group label="3 objectivos">
                  <b-form-input type="number" step="1" min="0" name="points_multiplier3" v-model="item.points_multiplier3" placeholder="3 objectivos"  v-validate="'required'" :state="validateState('points_multiplier3')"></b-form-input>
                  <b-form-invalid-feedback>
                    {{ errors.first('points_multiplier3') }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>

            </b-form-row>
          </b-form-fieldset>

          <div slot="footer">
            <div class="row">
              <div class="col-sm-3">
                <router-link :to="{name:'bestof.index'}" size="sm" variant="danger"><i class="fa fa-ban"></i> Cancelar</router-link>

              </div>
              <div class="col-sm-9 text-right">
                <b-button type="submit" size="sm" variant="primary"><i class="fa fa-save"></i> Gravar</b-button>
                <b-button type="button" v-on:click="validateBeforeSubmit($event,true)" size="sm" variant="primary"><i class="fa fa-save"></i> Gravar e fechar</b-button>
              </div>
            </div>
          </div>
        </b-card>


      </b-col>
      <b-col md="6">
        <b-card no-body>
          <b-tabs card>
            <b-tab title="Produtos" active>
              <b-card-text>
                <b-table hover :items="item.prodaggregs.data" :fields="prodaggregFields">
                  <template slot="index" slot-scope="data">
                    <button type="button" class="btn btn-danger" v-on:click="removeProdaggreg(data.index)"><i class="fa fa-times"></i></button>
                  </template>
                </b-table>

                <b-btn variant="success" @click="showProdaggregsModal"><i class="fa fa-plus"></i> adicionar</b-btn>
              </b-card-text>
            </b-tab>
            <b-tab title="Importar Prodaggregs" >
              <b-card-text>
                <p>Copiar objectivos no campo abaixo, separador por TAB<br><br>
                  codigo prodaggreg
                </p>
                <b-form-group>
                  <b-form-textarea v-model="importProdaggregs"></b-form-textarea>
                </b-form-group>
              </b-card-text>
            </b-tab>
            <b-tab title="Importar Objectivos Zona" >
              <b-card-text>
                <p>Copiar objectivos no campo abaixo, separador por TAB<br><br>
                  id do distribuidor <span class="text-danger">TAB</span> zona <span class="text-danger">TAB</span> obj valor <span class="text-danger">TAB</span> obj operadores <span class="text-danger">TAB</span> obj quantidade
                </p>
                <b-form-group>
                  <b-form-textarea v-model="importZoneObjectives"></b-form-textarea>
                </b-form-group>
              </b-card-text>
            </b-tab>
            <b-tab title="Importar Objectivos DSR" >
              <b-card-text>
                <p>Copiar objectivos no campo abaixo, separador por TAB<br><br>
                  id do dsr <span class="text-danger">TAB</span> zona <span class="text-danger">TAB</span> obj valor <span class="text-danger">TAB</span> obj operadores <span class="text-danger">TAB</span> obj quantidade
                </p>
                <b-form-group>
                  <b-form-textarea v-model="importDsrObjectives"></b-form-textarea>
                </b-form-group>
              </b-card-text>
            </b-tab>
            <b-tab title="Importar Objectivos Leader" >
              <b-card-text>
                <p>Copiar objectivos no campo abaixo, separador por TAB<br>
                  Se deixar em branco e importar objectivos DSR os objectivos dos Leaders vão ser calculados automáticamente<br><br>
                  id do dsr <span class="text-danger">TAB</span> zona <span class="text-danger">TAB</span> obj valor <span class="text-danger">TAB</span> obj operadores <span class="text-danger">TAB</span> obj quantidade
                </p>
                <b-form-group>
                  <b-form-textarea v-model="importLeaderObjectives"></b-form-textarea>
                </b-form-group>
              </b-card-text>
            </b-tab>

          </b-tabs>
        </b-card>
        <b-card>
          <div slot="header">
            <strong>Debug </strong>
          </div>

        </b-card>
      </b-col>
      <!--/.col-->

      <b-modal @shown="showProdaggregs=true" @hidden="showProdaggregs=false" size="lg" ref="prodaggregsModal" id="prodaggregsModal" no-enforce-focus>
        <prodaggregs v-if="showProdaggregs" height="400" v-on:select-prodaggreg="selectProdaggregs" />
      </b-modal>
    </div>
  </form>

</div>
</template>

<script>
import Prodaggregs from '@/views/products/prodaggregs/modal.vue'
import lists from '@/components/States.js'
export default {
  name: 'BestofEdit',
  props: ['id'],
  components: { Prodaggregs },
  data() {
    return {
      importZoneObjectives: '',
      importDsrObjectives: '',
      importLeaderObjectives: '',
      importProdaggregs: '',
      prodaggregFields: [
          // A column that needs custom formatting
        { key: 'id', label: 'Id' },
        { key: 'code', label: 'code' },
        { key: 'name', label: 'Name' },
        'index',
      ],
      objectivesFields: [
          // A column that needs custom formatting
        { key: 'dealer_id', label: 'Dist/CCSS' },
        { key: 'zone', label: 'Zona' },
        { key: 'value', label: 'Valor' },
        { key: 'operators', label: 'Operadores' },
        { key: 'quantity', label: 'Quantidade' },
        'index',
      ],
      dsrObjectivesFields: [
          // A column that needs custom formatting
        { key: 'dsr_id', label: 'ID' },
        { key: 'dsr_name', label: 'DSR' },
        { key: 'zone', label: 'Zona' },
        { key: 'value', label: 'Valor' },
        { key: 'operators', label: 'Operadores' },
        { key: 'quantity', label: 'Quantidade' },
        'index',
      ],
      showProdaggregs: false,
      showPassword: false,
      stateOptions: lists.states,
      item: {
        name: '',
        state: 0,
        points_multiplier1: 1,
        points_multiplier2: 1,
        points_multiplier3: 1,
        enable_value: 0,
        enable_quantity: 0,
        enable_operators: 0,
        objectives: {
          data: []
        },
        dsrobjectives: {
          data: []
        },
        leaderobjectives: {
          data: []
        },
        prodaggregs: {
          data: []
        }
      }
    }
  },
  methods: {
    removeProdaggreg(index) {
      this.item.prodaggregs.data.splice(index, 1)
    },
    selectProdaggregs(e) {
      this.item.prodaggregs.data.push({id: e.item.id, name: e.item.name, code: e.item.code})
      this.$refs.prodaggregsModal.hide()
    },
    showProdaggregsModal() {
      this.$refs.prodaggregsModal.show()
    },
    hideProdaggregsModal() {
      this.$refs.prodaggregsModal.hide()
    },
    validateBeforeSubmit(evt, close) {
      evt.preventDefault()
      console.log('check validation')
      this.$validator.validateAll().then((result) => {
        console.log('validation results:', result)
        if (result) {
          console.log('all fields ok. submit')
          this.submit(evt, close)
          return
        }
        this.$bvToast.toast(`Tem campos inválidos`, { autoHideDelay: 5000, variant: 'danger', solid: true })
      })
    },
    validateState(ref) {
      if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
        return !this.errors.has(ref)
      }
      return null
    },
    submit(e, close) {
      e.preventDefault()
      var data = {
        data: this.item,
        prodaggregs: this.importProdaggregs,
        zoneObjectives: this.importZoneObjectives,
        dsrObjectives: this.importDsrObjectives,
        leaderObjectives: this.importLeaderObjectives
      }
      if (this.item.id) {
        this.axios.put('bestof/campaigns' + '/' + this.item.id, data)
          .then(response => {
            this.item = response.data.data
            console.log('save ok')
            this.$bvToast.toast(`item gravado com sucesso`, {
              autoHideDelay: 5000
            })

            if (close) {
              this.$router.push({
                name: 'bestof.index'
              })
            }
          })
          .catch(response => {
            this.$bvToast.toast(`Não foi possivel gravar`, {
              autoHideDelay: 5000
            })
          })
      } else {
        this.axios.post('bestof/campaigns', data)
          .then(response => {
            this.item = response.data.data
            this.$bvToast.toast(`item gravado com sucesso`, {
              autoHideDelay: 5000
            })
            this.$router.push({
              name: 'bestof.edit',
              params: {
                id: this.item.id
              }
            })
          })
          .catch(response => {
            this.$bvToast.toast(`Não foi possivel gravar`, {
              autoHideDelay: 5000
            })
          })
      }
    }
  },
  created() {
    var id = this.$route.params.id
    if (typeof id !== 'undefined') {
      this.axios.get('bestof/campaigns' + '/' + id)
        .then(response => {
          this.item = response.data.data
        })
        .catch(response => {
          his.$bvToast.toast(`Este item não existe`, { autoHideDelay: 5000, variant: 'danger', solid: true })          
          this.$router.push({
            name: 'bestof.index'
          })
        })
    }
  }
}
</script>
